import { orchestrationBaseUrl, orchestrationVersion } from './environment';

export const url = `${orchestrationBaseUrl}/${orchestrationVersion}`;

export { orchestrationBaseUrl, orchestrationVersion };
